import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-900 flex flex-col sm:justify-start md:justify-start lg:justify-start pt-4 sm:pt-8 md:pt-12 sm:px-6 lg:px-8 overflow-y-auto" }
const _hoisted_2 = { class: "sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_3 = { class: "mt-2 text-center text-sm text-gray-400" }
const _hoisted_4 = { class: "mt-6 sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_5 = { class: "bg-gray-800 py-8 px-6 shadow-md sm:rounded-lg sm:px-10 border border-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LoginForm = _resolveComponent("LoginForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-center text-2xl md:text-3xl font-extrabold text-white" }, " Prijavi se na svoj nalog ", -1)),
      _createElementVNode("p", _hoisted_3, [
        _cache[1] || (_cache[1] = _createTextVNode(" Ili ")),
        _createVNode(_component_router_link, {
          to: "/register",
          class: "font-medium text-indigo-400 hover:text-indigo-300"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" kreiraj novi nalog ")
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_LoginForm, { onLoginSuccess: _ctx.onLoginSuccess }, null, 8, ["onLoginSuccess"])
      ])
    ])
  ]))
}